/**
 * ═══ QUAND CESSER DE GUETTER LES PHOTOS QUI ARRIVENT ═══
 *
 * La recherche des visages peut durer plus longtemps que l'API n'attend : elle rend
 * alors la main en disant qu'elle continue. Plutôt que de demander un rechargement de
 * page, l'album va voir de temps en temps si le compte de « mes photos » a bougé.
 *
 * Trois bornes, et chacune répare un défaut que l'autre laisserait passer :
 *
 *   TANT QUE ÇA MONTE, ON CONTINUE. Une recherche qui rattache trois cents photos les
 *   pose par paquets ; s'arrêter au premier palier montrerait un album à moitié rempli
 *   en annonçant qu'il est complet.
 *
 *   UN PALIER ASSEZ LONG ARRÊTE. Sans quoi on guetterait indéfiniment le cas le plus
 *   courant : une personne qui n'est sur aucune photo.
 *
 *   ET UN PLAFOND ABSOLU, parce qu'un traitement peut échouer de son côté sans que
 *   personne ici ne l'apprenne.
 *
 * Pure, donc la règle se vérifie sans navigateur ni minuterie.
 */

/** Le temps entre deux vérifications. */
export const POLL_EVERY_MS = 5000;

/** Le palier qui dit « c'est fini » : quatre vérifications sans rien de neuf. */
export const QUIET_MS = 20000;

/** Le plafond, quoi qu'il arrive. */
export const GIVE_UP_MS = 180000;

export type PollState = {
  /** Depuis le début de la surveillance. */
  elapsedMs: number;
  /** Depuis la dernière photo apparue. */
  sinceChangeMs: number;
};

export function keepPolling({ elapsedMs, sinceChangeMs }: PollState): boolean {
  if (elapsedMs >= GIVE_UP_MS) return false;
  return sinceChangeMs < QUIET_MS;
}
